/**
 * Created by Ivan on 18.02.2026
 */

Placements.ENTRIES["islandDecorationChest"] = {
    type: Placements.INTERMEDIATE,
    filter: function () {
        return cleverapps.environment.isMainScene() && IslandDecorationLogic.findRunningMission();
    },

    action: function () {
        cleverapps.missionManager.trigger("addPointsChest");
    }
};

Placements.ENTRIES["islandDecorationNudge"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,
    interval: "3 days",

    filter: function () {
        const mission = IslandDecorationLogic.findRunningMission();
        return Boolean(mission && !mission.needShowStartWindow && mission.logic.isAttentionRequired());
    },

    action: function () {
        const mission = IslandDecorationLogic.findRunningMission();

        cleverapps.focusManager.display({
            focus: "IslandDecorationNudge",
            action: function (f) {
                new IslandDecorationWindow(mission);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
